var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-authority"},[_c('a-empty',{attrs:{"description":'无访问权限'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }